import { render, staticRenderFns } from "./UserLinks.vue?vue&type=template&id=2d0ed610&"
import script from "./UserLinks.vue?vue&type=script&lang=ts&"
export * from "./UserLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports